import { useTranslation } from 'react-i18next';
import { Card, Col, Divider, Tooltip } from 'antd';
import { AppButton, Flex } from '@/components';
import { UserOutlined } from '@ant-design/icons';

export interface RoomCardGroupProps {
  floor: DormitoryFloorEntity;
  room: DormitoryFloorRoomEntity;
  onSelectRoom: () => void;
}

export default function RoomCardGroup({
  room,
  floor,
  onSelectRoom
}: RoomCardGroupProps) {

  const isFull = (room.roomSize - room.personCount) <= 0;
  const [t] = useTranslation(['common', 'dormitory']);

  return (
    <Col className="min-h-[200px]" xxl={6} lg={8} md={8} sm={12} xs={24}>
      <Card
        size="small"
        className="shadow-sm !h-full"
        styles={{ body: { height: '100%', display: 'flex', flexDirection: 'column' } }}
      >
        <Flex direction="column">
          <span>{t('dormitory:labels.floor')}: {floor.name}</span>
          <span>{t('dormitory:labels.room-code')}: {room.code}</span>
          <span>{t('common:labels.capacity')}: {room.roomSize}</span>
        </Flex>
        <Divider className="!mt-auto" />
        <Flex>
          <AppButton
            size="middle"
            type="primary"
            disabled={isFull}
            className="w-full h-[35px]"
            onClick={onSelectRoom}>
            {t('common:labels.select')}
          </AppButton>
          <Tooltip title={t('dormitory:labels.show-members')}>
            <AppButton
              size="middle"
              onClick={() => { }}
              disabled={true}
              className="text-base w-[35px] h-[35px]"
            >
              <Flex justify="center" align="center">
                <UserOutlined />
              </Flex>
            </AppButton>
          </Tooltip>
        </Flex>
      </Card>
    </Col>
  );
}
